// import React, { useState, useEffect } from 'react';
// import { useSelector } from 'react-redux';
// import '../../Styles/ManagementPages.css';
// import '../../Styles/CustomerManage.css';
// import { getConductors } from '../../Services/Operations/ProductAPI';

// const ConductorManagement = () => {
//   const { token } = useSelector(state => state.user);
//   const [conductors, setConductors] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [editingConductor, setEditingConductor] = useState(null);
//   const [editForm, setEditForm] = useState({});
//   const [viewingConductor, setViewingConductor] = useState(null);
//   const [error, setError] = useState(null);

//   // Pagination states
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [totalConductors, setTotalConductors] = useState(0);
//   const [pageSize] = useState(10);

//   // Calculate starting index for sequential numbering
//   const getSequentialNumber = (index) => {
//     return (currentPage - 1) * pageSize + index + 1;
//   };

//   // Fetch conductors on page or search change
//   useEffect(() => {
//     const delayDebounceFn = setTimeout(() => {
//       fetchConductors();
//     }, 500);

//     return () => clearTimeout(delayDebounceFn);
//   }, [currentPage, searchTerm]);

//   const fetchConductors = async () => {
//     try {
//       setLoading(true);
//       const response = await getConductors(token, currentPage, pageSize, searchTerm);

//       if (response && response.conductors) {
//         const transformedConductors = response.conductors.map((conductor, index) => ({
//           id: conductor._id,
//           serialNo: getSequentialNumber(index),
//           name: conductor.name || '',
//           mobileNumber: conductor.mobileNumber || '',
//           assignedBus: conductor.assignedBus || null,
//           busOwner: conductor.busOwner || null,
//           isActive: conductor.isActive || false,
//           joined: new Date(conductor.createdAt).toISOString().split('T')[0],
//           status: conductor.isActive ? 'Active' : 'Inactive',
//         }));

//         setConductors(transformedConductors);
//         setTotalPages(response.totalPages || 1);
//         setTotalConductors(response.total || 0);
//       }
//     } catch (err) {
//       setError('Failed to fetch conductors.');
//       console.error('Error fetching conductors:', err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleViewConductor = (conductor) => {
//     setViewingConductor({
//       ...conductor,
//       name: conductor.name || '',
//       mobileNumber: conductor.mobileNumber || '',
//       isActive: conductor.isActive,
//       assignedBus: conductor.assignedBus,
//       busOwner: conductor.busOwner,
//       joined: conductor.joined,
//     });
//   };

//   const handleSearchChange = (e) => {
//     setSearchTerm(e.target.value);
//     setCurrentPage(1);
//   };

//   const filteredConductors = conductors.filter(conductor =>
//     (conductor.name && conductor.name.toLowerCase().includes(searchTerm.toLowerCase())) ||
//     (conductor.mobileNumber && conductor.mobileNumber.includes(searchTerm)) ||
//     (conductor.busOwner?.name && conductor.busOwner.name.toLowerCase().includes(searchTerm.toLowerCase()))
//   );

//   const handleExportCSV = () => {
//     if (filteredConductors.length === 0) {
//       alert('No data to export');
//       return;
//     }

//     const headers = ['Serial No.', 'ID', 'Name', 'Mobile', 'Bus Owner', 'Assigned Bus', 'Status', 'Joined'];
//     const csvData = filteredConductors.map(conductor => [
//       conductor.serialNo,
//       conductor.id,
//       conductor.name || '',
//       conductor.mobileNumber || '',
//       conductor.busOwner?.name || 'N/A',
//       conductor.assignedBus?.busNumber || 'N/A',
//       conductor.status,
//       conductor.joined
//     ]);

//     const csvContent = [
//       headers.join(','),
//       ...csvData.map(row => row.map(field => `"${field}"`).join(','))
//     ].join('\n');

//     const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
//     const url = window.URL.createObjectURL(blob);
//     const link = document.createElement('a');
//     link.href = url;
//     link.download = `conductors-report-${new Date().toISOString().split('T')[0]}.csv`;
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//     window.URL.revokeObjectURL(url);

//     alert('CSV exported successfully!');
//   };

//   const handleEditConductor = (conductor) => {
//     setEditingConductor(conductor.id);
//     setEditForm({
//       name: conductor.name || '',
//       mobileNumber: conductor.mobileNumber || '',
//       status: conductor.status
//     });
//   };

//   const handleSaveEdit = async () => {
//     try {
//       setError(null);
      
//       // TODO: Implement updateConductor API call
//       // const updateData = {
//       //   name: editForm.name,
//       //   mobileNumber: editForm.mobileNumber,
//       //   isActive: editForm.status === 'Active'
//       // };
//       // 
//       // const response = await updateConductor(editingConductor, updateData, token);
      
//       // For now, update locally
//       setConductors(prevConductors =>
//         prevConductors.map(conductor =>
//           conductor.id === editingConductor ? {
//             ...conductor,
//             name: editForm.name,
//             mobileNumber: editForm.mobileNumber,
//             status: editForm.status,
//             isActive: editForm.status === 'Active'
//           } : conductor
//         )
//       );

//       setEditingConductor(null);
//       setEditForm({});
//       alert('Conductor updated successfully!');
//     } catch (err) {
//       console.error('Error updating conductor:', err);
//       setError('Failed to update conductor. Please try again.');
//       alert('Failed to update conductor. Please try again.');
//     }
//   };

//   const handleCancelEdit = () => {
//     setEditingConductor(null);
//     setEditForm({});
//     setError(null);
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setEditForm(prev => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   const closeViewModal = () => {
//     setViewingConductor(null);
//   };

//   const handleRefresh = () => {
//     setCurrentPage(1);
//     fetchConductors();
//   };

//   const handleNextPage = () => {
//     if (currentPage < totalPages) {
//       setCurrentPage(prev => prev + 1);
//     }
//   };

//   const handlePrevPage = () => {
//     if (currentPage > 1) {
//       setCurrentPage(prev => prev - 1);
//     }
//   };

//   const handlePageClick = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//   if (loading) {
//     return (
//       <div className="management-page">
//         <div className="loading-container">
//           <p>Loading conductors...</p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="management-page">
//       <div className="page-header">
//         <h1>Conductor Management</h1>
//         <div className="header-actions">
//           <input
//             type="text"
//             placeholder="Search conductors by name, mobile or bus owner..."
//             className="search-input"
//             value={searchTerm}
//             onChange={handleSearchChange}
//           />
//           <button className="refresh-btn" onClick={handleRefresh}>
//             Refresh
//           </button>
//           <button className="export-btn" onClick={handleExportCSV}>
//             Export CSV
//           </button>
//         </div>
//       </div>

//       {error && (
//         <div className="error-message">
//           {error}
//         </div>
//       )}

//       <div className="stats-cards">
//         <div className="stat-card">
//           <h3>Total Conductors</h3>
//           <p>{totalConductors || conductors.length}</p>
//           <span>All registered conductors</span>
//         </div>
//         <div className="stat-card">
//           <h3>Active Conductors</h3>
//           <p>{conductors.filter(c => c.status === 'Active').length}</p>
//           <span>Active conductors</span>
//         </div>
//         <div className="stat-card">
//           <h3>With Assigned Bus</h3>
//           <p>{conductors.filter(c => c.assignedBus).length}</p>
//           <span>Conductors with bus assignment</span>
//         </div>
//         <div className="stat-card">
//           <h3>Search Results</h3>
//           <p>{filteredConductors.length}</p>
//           <span>conductors found</span>
//         </div>
//       </div>

//       <div className="table-container">
//         <table className="data-table">
//           <thead>
//             <tr>
//               <th>No.</th>
//               <th>Name</th>
//               <th>Mobile</th>
//               <th>Bus Owner</th>
//               <th>Assigned Bus</th>
//               <th>Joined</th>
//               <th>Status</th>
//               <th>Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {filteredConductors.map(conductor => (
//               <tr key={conductor.id}>
//                 <td>{conductor.serialNo}</td>
//                 <td>
//                   {editingConductor === conductor.id ? (
//                     <input
//                       type="text"
//                       name="name"
//                       value={editForm.name || ''}
//                       onChange={handleInputChange}
//                       className="edit-input"
//                     />
//                   ) : (
//                     conductor.name || 'N/A'
//                   )}
//                 </td>
//                 <td>
//                   {editingConductor === conductor.id ? (
//                     <input
//                       type="text"
//                       name="mobileNumber"
//                       value={editForm.mobileNumber || ''}
//                       onChange={handleInputChange}
//                       className="edit-input"
//                     />
//                   ) : (
//                     conductor.mobileNumber || 'N/A'
//                   )}
//                 </td>
//                 <td>
//                   {conductor.busOwner?.name || 'N/A'}
//                 </td>
//                 <td>
//                   {conductor.assignedBus ? (
//                     <div className="bus-info">
//                       <div><strong>{conductor.assignedBus.busNumber}</strong></div>
//                       <small>{conductor.assignedBus.busName}</small>
//                     </div>
//                   ) : 'Not Assigned'}
//                 </td>
//                 <td>{conductor.joined}</td>
//                 <td>
//                   {editingConductor === conductor.id ? (
//                     <select
//                       name="status"
//                       value={editForm.status || ''}
//                       onChange={handleInputChange}
//                       className="edit-select"
//                     >
//                       <option value="Active">Active</option>
//                       <option value="Inactive">Inactive</option>
//                     </select>
//                   ) : (
//                     <span className={`status-badge ${conductor.status ? conductor.status.toLowerCase() : 'inactive'}`}>
//                       {conductor.status || 'Inactive'}
//                     </span>
//                   )}
//                 </td>
//                 <td>
//                   {editingConductor === conductor.id ? (
//                     <div className="edit-actions">
//                       <button className="action-btn save" onClick={handleSaveEdit}>
//                         Save
//                       </button>
//                       <button className="action-btn cancel" onClick={handleCancelEdit}>
//                         Cancel
//                       </button>
//                     </div>
//                   ) : (
//                     <div className="action-buttons">
//                       <button
//                         className="action-btn view"
//                         onClick={() => handleViewConductor(conductor)}
//                       >
//                         View
//                       </button>
//                       <button
//                         className="action-btn edit"
//                         onClick={() => handleEditConductor(conductor)}
//                       >
//                         Edit
//                       </button>
//                     </div>
//                   )}
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>

//         {filteredConductors.length === 0 && !loading && (
//           <div className="no-data">
//             <p>No conductors found matching your search.</p>
//           </div>
//         )}
//       </div>

//       <div className="pagination-container">
//         <div className="pagination-info">
//           Showing {conductors.length} of {totalConductors} conductors (Page {currentPage} of {totalPages})
//         </div>
//         <div className="pagination-controls">
//           <button
//             className="pagination-btn"
//             onClick={handlePrevPage}
//             disabled={currentPage === 1}
//           >
//             Previous
//           </button>

//           <div className="page-numbers">
//             {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
//               let pageNumber;
//               if (totalPages <= 5) {
//                 pageNumber = i + 1;
//               } else if (currentPage <= 3) {
//                 pageNumber = i + 1;
//               } else if (currentPage >= totalPages - 2) {
//                 pageNumber = totalPages - 4 + i;
//               } else {
//                 pageNumber = currentPage - 2 + i;
//               }

//               return (
//                 <button
//                   key={pageNumber}
//                   className={`page-number ${pageNumber === currentPage ? 'active' : ''}`}
//                   onClick={() => handlePageClick(pageNumber)}
//                 >
//                   {pageNumber}
//                 </button>
//               );
//             })}
//           </div>

//           <button
//             className="pagination-btn"
//             onClick={handleNextPage}
//             disabled={currentPage === totalPages}
//           >
//             Next
//           </button>
//         </div>
//       </div>

//       {viewingConductor && (
//         <div className="modal-overlay" onClick={closeViewModal}>
//           <div className="modal-content1" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h3>Conductor Details</h3>
//               <button className="modal-close-btn" onClick={closeViewModal}>
//                 ×
//               </button>
//             </div>
//             <div className="modal-body">
//               <div className="customer-details">
//                 <div className="detail-row">
//                   <label>Name:</label>
//                   <span>{viewingConductor.name || 'N/A'}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Mobile Number:</label>
//                   <span>{viewingConductor.mobileNumber || 'N/A'}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Bus Owner:</label>
//                   <span>
//                     {viewingConductor.busOwner ? (
//                       <div className="bus-owner-info">
//                         <strong>{viewingConductor.busOwner.name}</strong>
//                         <small>{viewingConductor.busOwner.phone}</small>
//                       </div>
//                     ) : 'N/A'}
//                   </span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Assigned Bus:</label>
//                   <span>
//                     {viewingConductor.assignedBus ? (
//                       <div className="bus-info">
//                         <strong>{viewingConductor.assignedBus.busNumber}</strong>
//                         <small>{viewingConductor.assignedBus.busName}</small>
//                       </div>
//                     ) : 'Not Assigned'}
//                   </span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Joined Date:</label>
//                   <span>{viewingConductor.joined}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Status:</label>
//                   <span className={`status-badge ${viewingConductor.status ? viewingConductor.status.toLowerCase() : 'inactive'}`}>
//                     {viewingConductor.status || 'Inactive'}
//                   </span>
//                 </div>
//               </div>
//             </div>
//             <div className="modal-footer">
//               <button className="modal-close-btn secondary" onClick={closeViewModal}>
//                 Close
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default ConductorManagement;

// import React, { useState, useEffect } from 'react';
// import { useSelector } from 'react-redux';
// import '../../Styles/ManagementPages.css';
// import '../../Styles/CustomerManage.css';
// import { getConductors, getConductorById, updateConductor } from '../../Services/Operations/ProductAPI';

// const ConductorManagement = () => {
//   const { token } = useSelector(state => state.user);
//   const [conductors, setConductors] = useState([]);
//   const [searching, setSearching] = useState(false);
//   const [loading, setLoading] = useState(true);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [editingConductor, setEditingConductor] = useState(null);
//   const [editForm, setEditForm] = useState({});
//   const [viewingConductor, setViewingConductor] = useState(null);
//   const [error, setError] = useState(null);
//   const [isFetchingDetails, setIsFetchingDetails] = useState(false);

//   // Pagination states
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [totalConductors, setTotalConductors] = useState(0);
//   const [pageSize] = useState(10);

//   // Calculate starting index for sequential numbering
//   const getSequentialNumber = (index) => {
//     return (currentPage - 1) * pageSize + index + 1;
//   };

//   // Fetch conductors on page or search change
//   useEffect(() => {
//     const delayDebounceFn = setTimeout(() => {
//       fetchConductors();
//     }, 500);

//     return () => clearTimeout(delayDebounceFn);
//   }, [currentPage, searchTerm]);

// const fetchConductors = async () => {
//   try {
//     setSearching(true);
//     setLoading(true);
//     const response = await getConductors(token, currentPage, pageSize, searchTerm);

//       if (response && response.conductors) {
//         const transformedConductors = response.conductors.map((conductor, index) => ({
//           id: conductor._id,
//           serialNo: getSequentialNumber(index),
//           profileImage: conductor.profileImage,
//           name: conductor.name || '',
//           mobileNumber: conductor.mobileNumber || '',

//           assignedBus: conductor.assignedBus || null,
//           busOwner: conductor.busOwner || null,
     
//           isActive: conductor.isActive || false,
//           joined: new Date(conductor.createdAt).toISOString().split('T')[0],
//           status: conductor.isActive ? 'Active' : 'Inactive',
//         }));

//         setConductors(transformedConductors);
//         setTotalPages(response.totalPages || 1);
//         setTotalConductors(response.total || 0);
//       }
//     } catch (err) {
//       setError('Failed to fetch conductors.');
//       console.error('Error fetching conductors:', err);
//    } finally {
//   setLoading(false);
//   setSearching(false);
// }
//   };

//   const handleViewConductor = async (conductorId) => {
//     try {
//       setIsFetchingDetails(true);
//       setError(null);
      
//       // Fetch detailed conductor information
//       const response = await getConductorById(conductorId, token);
      
//       if (response.success) {
//         const conductor = response.data;
//         setViewingConductor({
//           id: conductor._id,
//           name: conductor.name || '',
//           mobileNumber: conductor.mobileNumber || '',

//           isActive: conductor.isActive,
//           assignedBus: conductor.assignedBus || null,
//           busOwner: conductor.busOwner || null,

//           profileImage: conductor.profileImage,
//           createdAt: new Date(conductor.createdAt).toLocaleDateString('en-US', {
//             year: 'numeric',
//             month: 'long',
//             day: 'numeric'
//           }),
//           updatedAt: new Date(conductor.updatedAt).toLocaleDateString('en-US', {
//             year: 'numeric',
//             month: 'long',
//             day: 'numeric'
//           })
//         });
//       } else {
//         setError('Failed to fetch conductor details.');
//       }
//     } catch (err) {
//       console.error('Error fetching conductor details:', err);
//       setError('Failed to fetch conductor details.');
//     } finally {
//       setIsFetchingDetails(false);
//     }
//   };

//   const handleEditConductor = async (conductorId) => {
//     try {
//       setIsFetchingDetails(true);
//       setError(null);
      
//       // Fetch current conductor details for editing
//       const response = await getConductorById(conductorId, token);
      
//       if (response.success) {
//         const conductor = response.data;
//         setEditingConductor(conductor._id);
//         setEditForm({
//           name: conductor.name || '',
//           mobileNumber: conductor.mobileNumber || '',


//           isActive: conductor.isActive || true
//         });
//       } else {
//         setError('Failed to fetch conductor details for editing.');
//       }
//     } catch (err) {
//       console.error('Error fetching conductor details for editing:', err);
//       setError('Failed to fetch conductor details for editing.');
//     } finally {
//       setIsFetchingDetails(false);
//     }
//   };

//   const handleSaveEdit = async () => {
//     try {
//       setError(null);
      
//       // Prepare update data
//       const updateData = {
//         name: editForm.name,
//         mobileNumber: editForm.mobileNumber,


//         isActive: editForm.isActive
//       };

//       console.log('Updating conductor with data:', updateData);
      
//       const response = await updateConductor(editingConductor, updateData, token);
      
//       if (response.success) {
//         // Update local state
//         setConductors(prevConductors =>
//           prevConductors.map(conductor =>
//             conductor.id === editingConductor ? {
//               ...conductor,
//               name: response.data.name,
//               mobileNumber: response.data.mobileNumber,
 
       
//               status: response.data.isActive ? 'Active' : 'Inactive',
//               isActive: response.data.isActive
//             } : conductor
//           )
//         );

//         setEditingConductor(null);
//         setEditForm({});
//         alert('Conductor updated successfully!');
//       } else {
//         setError(response.message || 'Failed to update conductor.');
//       }
//     } catch (err) {
//       console.error('Error updating conductor:', err);
//       setError(err.response?.data?.message || 'Failed to update conductor. Please try again.');
//       alert('Failed to update conductor. Please try again.');
//     }
//   };

//   const handleCancelEdit = () => {
//     setEditingConductor(null);
//     setEditForm({});
//     setError(null);
//   };

//   const handleInputChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setEditForm(prev => ({
//       ...prev,
//       [name]: type === 'checkbox' ? checked : value
//     }));
//   };

//   const closeViewModal = () => {
//     setViewingConductor(null);
//   };

//   const handleSearchChange = (e) => {
//     setSearchTerm(e.target.value);
//     setCurrentPage(1);
//   };

// const handleRefresh = () => {
//   setSearchTerm('');
//   setCurrentPage(1);
//   // The useEffect will trigger fetchConductors automatically
// };

//   const handleExportCSV = () => {
//     if (conductors.length === 0) {
//       alert('No data to export');
//       return;
//     }

//     const headers = ['Serial No.', 'ID', 'Name', 'Mobile', 'Email', 'Address', 'Salary', 'Bus Owner', 'Assigned Bus', 'Status', 'Joined'];
//     const csvData = conductors.map(conductor => [
//       conductor.serialNo,
//       conductor.id,
//       conductor.name || '',
//       conductor.mobileNumber || '',
//       conductor.email || '',
//       conductor.address || '',
//       conductor.salary,
//       conductor.busOwner?.name || 'N/A',
//       conductor.assignedBus?.busNumber || 'N/A',
//       conductor.status,
//       conductor.joined
//     ]);

//     const csvContent = [
//       headers.join(','),
//       ...csvData.map(row => row.map(field => `"${field}"`).join(','))
//     ].join('\n');

//     const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
//     const url = window.URL.createObjectURL(blob);
//     const link = document.createElement('a');
//     link.href = url;
//     link.download = `conductors-report-${new Date().toISOString().split('T')[0]}.csv`;
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//     window.URL.revokeObjectURL(url);

//     alert('CSV exported successfully!');
//   };

//   const handleNextPage = () => {
//     if (currentPage < totalPages) {
//       setCurrentPage(prev => prev + 1);
//     }
//   };

//   const handlePrevPage = () => {
//     if (currentPage > 1) {
//       setCurrentPage(prev => prev - 1);
//     }
//   };

//   const handlePageClick = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

// if (loading && conductors.length === 0) {
//     return (
//       <div className="management-page">
//         <div className="loading-container">
//           <p>Loading conductors...</p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="management-page">
//       <div className="page-header">
//         <h1>Conductor Management</h1>
//         <div className="header-actions">
//          <div style={{ position: 'relative' }}>
//   <input
//     type="text"
//     placeholder="Search conductors by name, mobile, email or bus owner..."
//     className="search-input"
//     value={searchTerm}
//     onChange={handleSearchChange}
//     style={{ width: "70%" }}
//   />
//   {searching && (
//     <span style={{
//       position: 'absolute', right: '10px', top: '50%',
//       transform: 'translateY(-50%)', fontSize: '12px', color: '#888'
//     }}>
//       searching...
//     </span>
//   )}
// </div>
//           <button className="refresh-btn" onClick={handleRefresh}>
//             Refresh
//           </button>
//           <button className="export-btn" onClick={handleExportCSV}>
//             Export CSV
//           </button>
//         </div>
//       </div>

//       {error && (
//         <div className="error-message">
//           {error}
//         </div>
//       )}

//       <div className="stats-cards">
// <div className="stat-card">
//   <h3>Search Results</h3>
//   <p>{conductors.length}</p>
//   <span>conductors found</span>
// </div>
//         <div className="stat-card">
//           <h3>Active Conductors</h3>
//           <p>{conductors.filter(c => c.status === 'Active').length}</p>
//           <span>Active conductors</span>
//         </div>
//         <div className="stat-card">
//           <h3>With Assigned Bus</h3>
//           <p>{conductors.filter(c => c.assignedBus).length}</p>
//           <span>Conductors with bus assignment</span>
//         </div>
//         <div className="stat-card">
//           <h3>Average Salary</h3>
//           <p>₹{conductors.length > 0 ? 
//             Math.round(conductors.reduce((sum, c) => sum + (c.salary || 0), 0) / conductors.length) : 
//             0}</p>
//           <span>Average monthly salary</span>
//         </div>
//       </div>

//       <div className="table-container">
//         <table className="data-table">
//           <thead>
//             <tr>
//               <th>No.</th>
           
//               <th>Name</th>
//               <th>Mobile</th>
           
             
//               <th>Bus Owner</th>
//               <th>Assigned Bus</th>
//               <th>Status</th>
//               <th>Actions</th>
//             </tr>
//           </thead>
// <tbody>
//   {conductors.length > 0 ? (
//     conductors.map(conductor => (
//               <tr key={conductor.id}>
//                 <td>{conductor.serialNo}</td>
             
//                 <td>
//                   {editingConductor === conductor.id ? (
//                     <input
//                       type="text"
//                       name="name"
//                       value={editForm.name || ''}
//                       onChange={handleInputChange}
//                       className="edit-input"
//                       placeholder="Name"
//                     />
//                   ) : (
//                     conductor.name || 'N/A'
//                   )}
//                 </td>
//                 <td>
//                   {editingConductor === conductor.id ? (
//                     <input
//                       type="text"
//                       name="mobileNumber"
//                       value={editForm.mobileNumber || ''}
//                       onChange={handleInputChange}
//                       className="edit-input"
//                       placeholder="Mobile Number"
//                     />
//                   ) : (
//                     conductor.mobileNumber || 'N/A'
//                   )}
//                 </td>
               
              
//                 <td>
//                   {conductor.busOwner?.name || 'N/A'}
//                 </td>
//                 <td>
//                   {conductor.assignedBus ? (
//                     <div className="bus-info">
//                       <div><strong>{conductor.assignedBus.busNumber}</strong></div>
//                       <small>{conductor.assignedBus.busName}</small>
//                     </div>
//                   ) : 'Not Assigned'}
//                 </td>
//                 <td>
//                   {editingConductor === conductor.id ? (
//                     <label className="checkbox-label">
//                       <input
//                         type="checkbox"
//                         name="isActive"
//                         checked={editForm.isActive || false}
//                         onChange={handleInputChange}
//                       />
//                       <span className="checkbox-text">
//                         {editForm.isActive ? 'Active' : 'Inactive'}
//                       </span>
//                     </label>
//                   ) : (
//                     <span className={`status-badge ${conductor.status ? conductor.status.toLowerCase() : 'inactive'}`}>
//                       {conductor.status || 'Inactive'}
//                     </span>
//                   )}
//                 </td>
//                 <td>
//                   {editingConductor === conductor.id ? (
//                     <div className="edit-actions">
//                       <button className="action-btn save" onClick={handleSaveEdit} disabled={isFetchingDetails}>
//                         {isFetchingDetails ? 'Saving...' : 'Save'}
//                       </button>
//                       <button className="action-btn cancel" onClick={handleCancelEdit} disabled={isFetchingDetails}>
//                         Cancel
//                       </button>
//                     </div>
//                   ) : (
//                     <div className="action-buttons">
//                       <button
//                         className="action-btn view"
//                         onClick={() => handleViewConductor(conductor.id)}
//                         disabled={isFetchingDetails}
//                       >
//                         {isFetchingDetails ? 'Loading...' : 'View'}
//                       </button>
//                       <button
//                         className="action-btn edit"
//                         onClick={() => handleEditConductor(conductor.id)}
//                         disabled={isFetchingDetails}
//                       >
//                         {isFetchingDetails ? 'Loading...' : 'Edit'}
//                       </button>
//                     </div>
//                   )}
//                 </td>
//               </tr>
//               ))
//   ) : (
//     <tr>
//       <td colSpan="8" className="no-data">
//         <p>No conductors found {searchTerm ? 'matching your search' : ''}.</p>
//         {searchTerm && (
//           <button className="clear-filters-link" onClick={handleRefresh}>
//             Clear search to see all conductors
//           </button>
//         )}
//       </td>
//     </tr>
//   )}
//           </tbody>
//         </table>

//         {conductors.length === 0 && !loading && (
//           <div className="no-data">
//             <p>No conductors found matching your search.</p>
//           </div>
//         )}
//       </div>

//       <div className="pagination-container">
// <div className="pagination-info">
//   Showing {conductors.length} of {totalConductors} conductors
//   (Page {currentPage} of {totalPages})
//   {searchTerm && <span className="filtered-indicator"> • Search: "{searchTerm}"</span>}
// </div>
//         <div className="pagination-controls">
//           <button
//             className="pagination-btn"
//             onClick={handlePrevPage}
//             disabled={currentPage === 1}
//           >
//             Previous
//           </button>

//           <div className="page-numbers">
//             {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
//               let pageNumber;
//               if (totalPages <= 5) {
//                 pageNumber = i + 1;
//               } else if (currentPage <= 3) {
//                 pageNumber = i + 1;
//               } else if (currentPage >= totalPages - 2) {
//                 pageNumber = totalPages - 4 + i;
//               } else {
//                 pageNumber = currentPage - 2 + i;
//               }

//               return (
//                 <button
//                   key={pageNumber}
//                   className={`page-number ${pageNumber === currentPage ? 'active' : ''}`}
//                   onClick={() => handlePageClick(pageNumber)}
//                 >
//                   {pageNumber}
//                 </button>
//               );
//             })}
//           </div>

//           <button
//             className="pagination-btn"
//             onClick={handleNextPage}
//             disabled={currentPage === totalPages}
//           >
//             Next
//           </button>
//         </div>
//       </div>

// {/* View Conductor Modal */}
// {viewingConductor && (
//   <div className="modal-overlay" onClick={closeViewModal}>
//     <div className="modal-content1" onClick={(e) => e.stopPropagation()}>
//       <div className="modal-header">
//         <h3>Conductor Details</h3>
//         <button className="modal-close-btn" onClick={closeViewModal}>
//           ×
//         </button>
//       </div>
//       <div className="modal-body">
//         <div className="customer-details">
//           {/* Profile Image Section */}
//           <div className="profile-image-section">
//             <img
//               src={viewingConductor.profileImage ? 
//                 `${process.env.REACT_APP_BASE_URL}/uploads/${viewingConductor.profileImage}` : 
//                 '/default-profile.png'}
//               alt={viewingConductor.name || 'Conductor'}
//               className="profile-image-large"
//               onError={(e) => {
//                 e.target.onerror = null;
//                 e.target.src = '/default-profile.png';
//               }}
//             />
//           </div>
          
//           {/* Details in the format from your image */}
//           <div className="details-grid">
//             <div className="detail-section">
//               <h4>Name:</h4>
//               <p>{viewingConductor.name || 'N/A'}</p>
//             </div>
            
//             <div className="detail-section">
//               <h4>Mobile Number:</h4>
//               <p>{viewingConductor.mobileNumber || 'N/A'}</p>
//             </div>
            
          
            
//             <div className="detail-section">
//               <h4>Status:</h4>
//               <span className={`status-badge ${viewingConductor.isActive ? 'active' : 'inactive'}`}>
//                 {viewingConductor.isActive ? 'Active' : 'Inactive'}
//               </span>
//             </div>
            
//             {/* Bus Owner and Assigned Bus in separate sections */}
//             {viewingConductor.busOwner && (
//               <div className="detail-section full-width">
//                 <h4>Bus Owner:</h4>
//                 <div className="bus-owner-details">
//                   <p><strong>Name:</strong> {viewingConductor.busOwner.name}</p>
//                   <p><strong>Phone:</strong> {viewingConductor.busOwner.phone}</p>
                 
//                 </div>
//               </div>
//             )}
            
//             {viewingConductor.assignedBus && (
//               <div className="detail-section full-width">
//                 <h4>Assigned Bus:</h4>
//                 <div className="bus-details">
//                   <p><strong>Bus Number:</strong> {viewingConductor.assignedBus.busNumber}</p>
//                   <p><strong>Bus Name:</strong> {viewingConductor.assignedBus.busName}</p>
//                   {viewingConductor.assignedBus.routeNumber && (
//                     <p><strong>Route:</strong> {viewingConductor.assignedBus.routeNumber}</p>
//                   )}
//                 </div>
//               </div>
//             )}
            
//             {/* Date information at the bottom */}
//             <div className="detail-section">
//               <h4>Joined Date:</h4>
//               <p>{viewingConductor.createdAt}</p>
//             </div>
            
//             <div className="detail-section">
//               <h4>Last Updated:</h4>
//               <p>{viewingConductor.updatedAt}</p>
//             </div>
//           </div>
//         </div>
//       </div>
//       <div className="modal-footer">
//         <button className="modal-close-btn secondary" onClick={closeViewModal}>
//           Close
//         </button>
//       </div>
//     </div>
//   </div>
// )}

//       {/* Edit Form Modal (for more complex edits) */}
//       {editingConductor && (
//         <div className="modal-overlay" onClick={handleCancelEdit}>
//           <div className="modal-content1 edit-modal" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h3>Edit Conductor</h3>
//               <button className="modal-close-btn" onClick={handleCancelEdit}>
//                 ×
//               </button>
//             </div>
//             <div className="modal-body">
//               <div className="edit-form">
//                 <div className="form-group">
//                   <label>Name:</label>
//                   <input
//                     type="text"
//                     name="name"
//                     value={editForm.name || ''}
//                     onChange={handleInputChange}
//                     className="form-control"
//                     placeholder="Conductor Name"
//                   />
//                 </div>
//                 <div className="form-group">
//                   <label>Mobile Number:</label>
//                   <input
//                     type="text"
//                     name="mobileNumber"
//                     value={editForm.mobileNumber || ''}
//                     onChange={handleInputChange}
//                     className="form-control"
//                     placeholder="Mobile Number"
//                   />
//                 </div>
              
               
//                 <div className="form-group checkbox-group">
//                   <label className="checkbox-label">
//                     <input
//                       type="checkbox"
//                       name="isActive"
//                       checked={editForm.isActive || false}
//                       onChange={handleInputChange}
//                     />
//                     <span className="checkbox-text">Active Conductor</span>
//                   </label>
//                 </div>
//               </div>
//             </div>
//             <div className="modal-footer">
//               <button className="action-btn cancel" onClick={handleCancelEdit}>
//                 Cancel
//               </button>
//               <button className="action-btn save" onClick={handleSaveEdit} disabled={isFetchingDetails}>
//                 {isFetchingDetails ? 'Saving...' : 'Save Changes'}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default ConductorManagement;

import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import '../../Styles/ManagementPages.css';
import '../../Styles/CustomerManage.css';
import { getConductors, getConductorById, updateConductor } from '../../Services/Operations/ProductAPI';

// Skeleton Components
const SkeletonStatsCard = () => (
  <div className="stat-card skeleton">
    <div className="skeleton-title"></div>
    <div className="skeleton-value"></div>
    <div className="skeleton-subtitle"></div>
  </div>
);

const SkeletonTableRow = () => (
  <tr className="skeleton-row">
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-cell"></div></td>
    <td><div className="skeleton-badge"></div></td>
    <td><div className="skeleton-actions"></div></td>
  </tr>
);

const SkeletonTable = () => (
  <div className="table-container skeleton">
    <table className="data-table">
      <thead>
        <tr>
          <th>No.</th>
          <th>Name</th>
          <th>Mobile</th>
          <th>Bus Owner</th>
          <th>Assigned Bus</th>
          <th>Status</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i) => (
          <SkeletonTableRow key={i} />
        ))}
      </tbody>
    </table>
  </div>
);

const SkeletonModal = () => (
  <div className="modal-overlay">
    <div className="modal-content1 skeleton-modal">
      <div className="modal-header">
        <div className="skeleton-title"></div>
        <div className="skeleton-close"></div>
      </div>
      <div className="modal-body">
        <div className="skeleton-profile-image"></div>
        <div className="details-grid">
          {[1, 2, 3, 4, 5, 6].map((i) => (
            <div key={i} className="detail-section">
              <div className="skeleton-label"></div>
              <div className="skeleton-value"></div>
            </div>
          ))}
        </div>
      </div>
      <div className="modal-footer">
        <div className="skeleton-button"></div>
      </div>
    </div>
  </div>
);

const SkeletonEditModal = () => (
  <div className="modal-overlay">
    <div className="modal-content1 edit-modal skeleton-modal">
      <div className="modal-header">
        <div className="skeleton-title"></div>
        <div className="skeleton-close"></div>
      </div>
      <div className="modal-body">
        {[1, 2, 3, 4].map((i) => (
          <div key={i} className="form-group">
            <div className="skeleton-label"></div>
            <div className="skeleton-input"></div>
          </div>
        ))}
      </div>
      <div className="modal-footer">
        <div className="skeleton-button"></div>
        <div className="skeleton-button"></div>
      </div>
    </div>
  </div>
);

const ConductorManagement = () => {
  const { token } = useSelector(state => state.user);
  const [conductors, setConductors] = useState([]);
  const [searching, setSearching] = useState(false);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [editingConductor, setEditingConductor] = useState(null);
  const [editForm, setEditForm] = useState({});
  const [viewingConductor, setViewingConductor] = useState(null);
  const [error, setError] = useState(null);
  const [isFetchingDetails, setIsFetchingDetails] = useState(false);

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalConductors, setTotalConductors] = useState(0);
  const [pageSize] = useState(10);

  // Calculate starting index for sequential numbering
  const getSequentialNumber = (index) => {
    return (currentPage - 1) * pageSize + index + 1;
  };

  // Fetch conductors on page or search change
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      fetchConductors();
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [currentPage, searchTerm]);

  const fetchConductors = async () => {
    try {
      setSearching(true);
      setLoading(true);
      const response = await getConductors(token, currentPage, pageSize, searchTerm);

      if (response && response.conductors) {
        const transformedConductors = response.conductors.map((conductor, index) => ({
          id: conductor._id,
          serialNo: getSequentialNumber(index),
          profileImage: conductor.profileImage,
          name: conductor.name || '',
          mobileNumber: conductor.mobileNumber || '',
          assignedBus: conductor.assignedBus || null,
          busOwner: conductor.busOwner || null,
          isActive: conductor.isActive || false,
          joined: new Date(conductor.createdAt).toISOString().split('T')[0],
          status: conductor.isActive ? 'Active' : 'Inactive',
        }));

        setConductors(transformedConductors);
        setTotalPages(response.totalPages || 1);
        setTotalConductors(response.total || 0);
      }
    } catch (err) {
      setError('Failed to fetch conductors.');
      console.error('Error fetching conductors:', err);
    } finally {
      setLoading(false);
      setSearching(false);
    }
  };

  const handleViewConductor = async (conductorId) => {
    try {
      setIsFetchingDetails(true);
      setError(null);
      
      const response = await getConductorById(conductorId, token);
      
      if (response.success) {
        const conductor = response.data;
        setViewingConductor({
          id: conductor._id,
          name: conductor.name || '',
          mobileNumber: conductor.mobileNumber || '',
          isActive: conductor.isActive,
          assignedBus: conductor.assignedBus || null,
          busOwner: conductor.busOwner || null,
          profileImage: conductor.profileImage,
          createdAt: new Date(conductor.createdAt).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          }),
          updatedAt: new Date(conductor.updatedAt).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          })
        });
      } else {
        setError('Failed to fetch conductor details.');
      }
    } catch (err) {
      console.error('Error fetching conductor details:', err);
      setError('Failed to fetch conductor details.');
    } finally {
      setIsFetchingDetails(false);
    }
  };

  const handleEditConductor = async (conductorId) => {
    try {
      setIsFetchingDetails(true);
      setError(null);
      
      const response = await getConductorById(conductorId, token);
      
      if (response.success) {
        const conductor = response.data;
        setEditingConductor(conductor._id);
        setEditForm({
          name: conductor.name || '',
          mobileNumber: conductor.mobileNumber || '',
          isActive: conductor.isActive || true
        });
      } else {
        setError('Failed to fetch conductor details for editing.');
      }
    } catch (err) {
      console.error('Error fetching conductor details for editing:', err);
      setError('Failed to fetch conductor details for editing.');
    } finally {
      setIsFetchingDetails(false);
    }
  };

  const handleSaveEdit = async () => {
    try {
      setError(null);
      
      const updateData = {
        name: editForm.name,
        mobileNumber: editForm.mobileNumber,
        isActive: editForm.isActive
      };

      console.log('Updating conductor with data:', updateData);
      
      const response = await updateConductor(editingConductor, updateData, token);
      
      if (response.success) {
        setConductors(prevConductors =>
          prevConductors.map(conductor =>
            conductor.id === editingConductor ? {
              ...conductor,
              name: response.data.name,
              mobileNumber: response.data.mobileNumber,
              status: response.data.isActive ? 'Active' : 'Inactive',
              isActive: response.data.isActive
            } : conductor
          )
        );

        setEditingConductor(null);
        setEditForm({});
        alert('Conductor updated successfully!');
      } else {
        setError(response.message || 'Failed to update conductor.');
      }
    } catch (err) {
      console.error('Error updating conductor:', err);
      setError(err.response?.data?.message || 'Failed to update conductor. Please try again.');
      alert('Failed to update conductor. Please try again.');
    }
  };

  const handleCancelEdit = () => {
    setEditingConductor(null);
    setEditForm({});
    setError(null);
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setEditForm(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const closeViewModal = () => {
    setViewingConductor(null);
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const handleRefresh = () => {
    setSearchTerm('');
    setCurrentPage(1);
  };

  const handleExportCSV = () => {
    if (conductors.length === 0) {
      alert('No data to export');
      return;
    }

    const headers = ['Serial No.', 'ID', 'Name', 'Mobile', 'Bus Owner', 'Assigned Bus', 'Status', 'Joined'];
    const csvData = conductors.map(conductor => [
      conductor.serialNo,
      conductor.id,
      conductor.name || '',
      conductor.mobileNumber || '',
      conductor.busOwner?.name || 'N/A',
      conductor.assignedBus?.busNumber || 'N/A',
      conductor.status,
      conductor.joined
    ]);

    const csvContent = [
      headers.join(','),
      ...csvData.map(row => row.map(field => `"${field}"`).join(','))
    ].join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `conductors-report-${new Date().toISOString().split('T')[0]}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    alert('CSV exported successfully!');
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(prev => prev + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(prev => prev - 1);
    }
  };

  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Loading state with skeletons
  if (loading && conductors.length === 0) {
    return (
      <div className="management-page">
        <div className="page-header">
          <div className="skeleton-header-title"></div>
          <div className="header-actions">
            <div className="skeleton-search"></div>
            <div className="skeleton-button"></div>
            <div className="skeleton-button"></div>
          </div>
        </div>

        <div className="stats-cards">
          {[1, 2, 3, 4].map((i) => (
            <SkeletonStatsCard key={i} />
          ))}
        </div>

        <SkeletonTable />

        <div className="pagination-container">
          <div className="skeleton-pagination-info"></div>
          <div className="skeleton-pagination-controls"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="management-page">
      <div className="page-header">
        <h1>Conductor Management</h1>
        <div className="header-actions">
          <div style={{ position: 'relative' }}>
            <input
              type="text"
              placeholder="Search conductors by name, mobile, or bus owner..."
              className="search-input"
              value={searchTerm}
              onChange={handleSearchChange}
              style={{ width: "70%" }}
            />
            {searching && (
              <span style={{
                position: 'absolute', right: '10px', top: '50%',
                transform: 'translateY(-50%)', fontSize: '12px', color: '#888'
              }}>
                searching...
              </span>
            )}
          </div>
          <button className="refresh-btn" onClick={handleRefresh}>
            Refresh
          </button>
          <button className="export-btn" onClick={handleExportCSV}>
            Export CSV
          </button>
        </div>
      </div>

      {error && (
        <div className="error-message">
          {error}
        </div>
      )}

      <div className="stats-cards">
        <div className="stat-card">
          <h3>Total Conductors</h3>
          <p>{totalConductors}</p>
          <span>All registered conductors</span>
        </div>
        <div className="stat-card">
          <h3>Active Conductors</h3>
          <p>{conductors.filter(c => c.status === 'Active').length}</p>
          <span>Active conductors</span>
        </div>
        <div className="stat-card">
          <h3>With Assigned Bus</h3>
          <p>{conductors.filter(c => c.assignedBus).length}</p>
          <span>Conductors with bus assignment</span>
        </div>
        <div className="stat-card">
          <h3>Search Results</h3>
          <p>{conductors.length}</p>
          <span>conductors found</span>
        </div>
      </div>

      <div className="table-container">
        <table className="data-table">
          <thead>
            <tr>
              <th>No.</th>
              <th>Name</th>
              <th>Mobile</th>
              <th>Bus Owner</th>
              <th>Assigned Bus</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {conductors.length > 0 ? (
              conductors.map(conductor => (
                <tr key={conductor.id}>
                  <td>{conductor.serialNo}</td>
                  <td>
                    {editingConductor === conductor.id ? (
                      <input
                        type="text"
                        name="name"
                        value={editForm.name || ''}
                        onChange={handleInputChange}
                        className="edit-input"
                        placeholder="Name"
                      />
                    ) : (
                      conductor.name || 'N/A'
                    )}
                  </td>
                  <td>
                    {editingConductor === conductor.id ? (
                      <input
                        type="text"
                        name="mobileNumber"
                        value={editForm.mobileNumber || ''}
                        onChange={handleInputChange}
                        className="edit-input"
                        placeholder="Mobile Number"
                      />
                    ) : (
                      conductor.mobileNumber || 'N/A'
                    )}
                  </td>
                  <td>
                    {conductor.busOwner?.name || 'N/A'}
                  </td>
                  <td>
                    {conductor.assignedBus ? (
                      <div className="bus-info">
                        <div><strong>{conductor.assignedBus.busNumber}</strong></div>
                        <small>{conductor.assignedBus.busName}</small>
                      </div>
                    ) : 'Not Assigned'}
                  </td>
                  <td>
                    {editingConductor === conductor.id ? (
                      <label className="checkbox-label">
                        <input
                          type="checkbox"
                          name="isActive"
                          checked={editForm.isActive || false}
                          onChange={handleInputChange}
                        />
                        <span className="checkbox-text">
                          {editForm.isActive ? 'Active' : 'Inactive'}
                        </span>
                      </label>
                    ) : (
                      <span className={`status-badge ${conductor.status ? conductor.status.toLowerCase() : 'inactive'}`}>
                        {conductor.status || 'Inactive'}
                      </span>
                    )}
                  </td>
                  <td>
                    {editingConductor === conductor.id ? (
                      <div className="edit-actions">
                        <button className="action-btn save" onClick={handleSaveEdit} disabled={isFetchingDetails}>
                          {isFetchingDetails ? 'Saving...' : 'Save'}
                        </button>
                        <button className="action-btn cancel" onClick={handleCancelEdit} disabled={isFetchingDetails}>
                          Cancel
                        </button>
                      </div>
                    ) : (
                      <div className="action-buttons">
                        <button
                          className="action-btn view"
                          onClick={() => handleViewConductor(conductor.id)}
                          disabled={isFetchingDetails}
                        >
                          {isFetchingDetails ? 'Loading...' : 'View'}
                        </button>
                        <button
                          className="action-btn edit"
                          onClick={() => handleEditConductor(conductor.id)}
                          disabled={isFetchingDetails}
                        >
                          {isFetchingDetails ? 'Loading...' : 'Edit'}
                        </button>
                      </div>
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="no-data">
                  <p>No conductors found {searchTerm ? 'matching your search' : ''}.</p>
                  {searchTerm && (
                    <button className="clear-filters-link" onClick={handleRefresh}>
                      Clear search to see all conductors
                    </button>
                  )}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div className="pagination-container">
        <div className="pagination-info">
          Showing {conductors.length} of {totalConductors} conductors
          (Page {currentPage} of {totalPages})
          {searchTerm && <span className="filtered-indicator"> • Search: "{searchTerm}"</span>}
        </div>
        <div className="pagination-controls">
          <button
            className="pagination-btn"
            onClick={handlePrevPage}
            disabled={currentPage === 1}
          >
            Previous
          </button>

          <div className="page-numbers">
            {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
              let pageNumber;
              if (totalPages <= 5) {
                pageNumber = i + 1;
              } else if (currentPage <= 3) {
                pageNumber = i + 1;
              } else if (currentPage >= totalPages - 2) {
                pageNumber = totalPages - 4 + i;
              } else {
                pageNumber = currentPage - 2 + i;
              }

              return (
                <button
                  key={pageNumber}
                  className={`page-number ${pageNumber === currentPage ? 'active' : ''}`}
                  onClick={() => handlePageClick(pageNumber)}
                >
                  {pageNumber}
                </button>
              );
            })}
          </div>

          <button
            className="pagination-btn"
            onClick={handleNextPage}
            disabled={currentPage === totalPages}
          >
            Next
          </button>
        </div>
      </div>

      {/* View Conductor Modal */}
      {viewingConductor && !isFetchingDetails && (
        <div className="modal-overlay" onClick={closeViewModal}>
          <div className="modal-content1" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Conductor Details</h3>
              <button className="modal-close-btn" onClick={closeViewModal}>
                ×
              </button>
            </div>
            <div className="modal-body">
              <div className="customer-details">
                <div className="profile-image-section">
                  <img
                    src={viewingConductor.profileImage ? 
                      `${process.env.REACT_APP_BASE_URL}/uploads/${viewingConductor.profileImage}` : 
                      '/default-profile.png'}
                    alt={viewingConductor.name || 'Conductor'}
                    className="profile-image-large"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = '/default-profile.png';
                    }}
                  />
                </div>
                
                <div className="details-grid">
                  <div className="detail-section">
                    <h4>Name:</h4>
                    <p>{viewingConductor.name || 'N/A'}</p>
                  </div>
                  
                  <div className="detail-section">
                    <h4>Mobile Number:</h4>
                    <p>{viewingConductor.mobileNumber || 'N/A'}</p>
                  </div>
                  
                  <div className="detail-section">
                    <h4>Status:</h4>
                    <span className={`status-badge ${viewingConductor.isActive ? 'active' : 'inactive'}`}>
                      {viewingConductor.isActive ? 'Active' : 'Inactive'}
                    </span>
                  </div>
                  
                  {viewingConductor.busOwner && (
                    <div className="detail-section full-width">
                      <h4>Bus Owner:</h4>
                      <div className="bus-owner-details">
                        <p><strong>Name:</strong> {viewingConductor.busOwner.name}</p>
                        <p><strong>Phone:</strong> {viewingConductor.busOwner.phone}</p>
                      </div>
                    </div>
                  )}
                  
                  {viewingConductor.assignedBus && (
                    <div className="detail-section full-width">
                      <h4>Assigned Bus:</h4>
                      <div className="bus-details">
                        <p><strong>Bus Number:</strong> {viewingConductor.assignedBus.busNumber}</p>
                        <p><strong>Bus Name:</strong> {viewingConductor.assignedBus.busName}</p>
                      </div>
                    </div>
                  )}
                  
                  <div className="detail-section">
                    <h4>Joined Date:</h4>
                    <p>{viewingConductor.createdAt}</p>
                  </div>
                  
                  <div className="detail-section">
                    <h4>Last Updated:</h4>
                    <p>{viewingConductor.updatedAt}</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button className="modal-close-btn secondary" onClick={closeViewModal}>
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Loading state for view modal */}
      {viewingConductor && isFetchingDetails && <SkeletonModal />}

      {/* Edit Form Modal */}
      {editingConductor && !isFetchingDetails && (
        <div className="modal-overlay" onClick={handleCancelEdit}>
          <div className="modal-content1 edit-modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Edit Conductor</h3>
              <button className="modal-close-btn" onClick={handleCancelEdit}>
                ×
              </button>
            </div>
            <div className="modal-body">
              <div className="edit-form">
                <div className="form-group">
                  <label>Name:</label>
                  <input
                    type="text"
                    name="name"
                    value={editForm.name || ''}
                    onChange={handleInputChange}
                    className="form-control"
                    placeholder="Conductor Name"
                  />
                </div>
                <div className="form-group">
                  <label>Mobile Number:</label>
                  <input
                    type="text"
                    name="mobileNumber"
                    value={editForm.mobileNumber || ''}
                    onChange={handleInputChange}
                    className="form-control"
                    placeholder="Mobile Number"
                  />
                </div>
                <div className="form-group checkbox-group">
                  <label className="checkbox-label">
                    <input
                      type="checkbox"
                      name="isActive"
                      checked={editForm.isActive || false}
                      onChange={handleInputChange}
                    />
                    <span className="checkbox-text">Active Conductor</span>
                  </label>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button className="action-btn cancel" onClick={handleCancelEdit}>
                Cancel
              </button>
              <button className="action-btn save" onClick={handleSaveEdit}>
                Save Changes
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Loading state for edit modal */}
      {editingConductor && isFetchingDetails && <SkeletonEditModal />}
    </div>
  );
};

export default ConductorManagement;